import {forEach} from 'ramda';
import {curry} from 'ramda';

const findClsRemove = (element, delClasses) => {
	forEach(item => {
		item.classList.remove(delClasses);
	}, element.querySelectorAll('.' + delClasses));
};

export default curry(findClsRemove);



// WEBPACK FOOTER //
// ./app/scripts/util/findClsRemove.js